import { Grid } from "@mui/material";

import {
  RRDAddressArea,
  RRDCouponGrid,
  RRDExpirationText,
  RRDImageSlot,
} from "./RRDTemplateSlots";
import { couponSlots, slotsByType } from "./rrdLayoutSlotHelpers";
import type { RRDLayoutProps } from "./layoutTypes";

function BasicPostcard6CLayout(props: RRDLayoutProps) {
  const { layoutSpec, heroImages, coupons, frontExpirationDate, mode } = props;
  const heroSlot = slotsByType(layoutSpec, "hero_image")[0];

  return (
    <Grid size={{ xs: 12, lg: props.fullWidth ? 12 : 6 }}>
      <Grid container spacing={0}>
        <Grid size={5}>
          <RRDImageSlot
            {...props}
            slot={heroSlot}
            placeholder="Hero Image"
            sx={{ aspectRatio: heroSlot.aspectRatio }}
          />
        </Grid>
        <Grid size={7}>
          <RRDAddressArea />
        </Grid>
      </Grid>
      <RRDCouponGrid
        slots={couponSlots(layoutSpec, "front")}
        layoutSpec={layoutSpec}
        heroImages={heroImages}
        coupons={coupons}
        mode={mode}
        onOpenMobileSlot={props.onOpenMobileSlot}
        onRemoveAsset={props.onRemoveAsset}
        readOnly={props.readOnly}
      />
      <RRDExpirationText>{frontExpirationDate}</RRDExpirationText>
    </Grid>
  );
}

export default BasicPostcard6CLayout;
